import { AnswerModeEnum, ExamModeEnum, QuestAnswerStatus } from '~/src/constants/exam';

export enum ExamResultStatus {
  Success = 'success',
  Failed = 'failed',
}

export interface QuestionResultItem {
  id: number;
  serialNumber: number;
  status: QuestAnswerStatus;
}

// 考试结果页面状态
export interface ExamResultPageStatus {
  meta: {
    /**
     * 页面展示模式:
     * 1: 每日打卡
     * 2: 考试结果
     */
    mode: ExamModeEnum;
    title: string;
    punchCardTime: string;
    status: string;
    examPaperId?: string;
    answerId?: string;
    answerMode?: AnswerModeEnum;
    answerType?: string;
    submitId?: string;
    // 章ID
    chapterId?: string;
    // 节ID
    sectionId?: string;
    isFinished?: boolean;
    date?: string;
    sectionName?: string;
    version?: string;
    autoShowPoster?: string;
    userSubject?: string;
    today?: string;
    highFrequency?: string;
    id: string;
    number?: string;
  };
  dashboard: {
    total: number;
    done: number;
    undo: number;
    success: number;
    failed: number;
    accuracy: number;
    duration: number;
    progress: number;
    submitTotalQuestion: number;
    todayTotalQuestion: number;
    continueSignCount?: number;
    currentlyDayCount?: number;
    totalSignCount?: number;
    signTop?: number;
    pcScore?: number;
  };
  questList: QuestionResultItem[];
}
